import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { Occ, OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class UserUidService {
  constructor(private occEndpointsService: OccEndpointsService, private http: HttpClient) {}

  getUserUid(accessToken: string): Observable<string> {
    const url = this.occEndpointsService.buildUrl('userUid', { urlParams: { userId: 'current' } });
    const headers = { Authorization: 'Bearer ' + accessToken + '.REMOTE' };
    return this.http.get<Occ.User>(url, { headers }).pipe(
      map(({ uid }) => uid)
    );
  }

  getUserToken(accessToken: string): Observable<string> {
    const url = this.occEndpointsService.buildUrl('userToken', { urlParams: { userId: 'current' } });
    const headers = { Authorization: 'Bearer ' + accessToken + '.REMOTE' };
    return this.http.get<string>(url, { headers, responseType: 'string' as 'json' });
  }
}
